import * as React from "react";
import { HudXp } from "../../xp/HudXp";
export var BF2HudTop = function () { return React.createElement(HudXp, null); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudTop.tsx
// module id = 2299
// module chunks = 3